<script>
import { BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
    components: {BFormGroup, vSelect},
    props: {
        readOnly: {
            default: false,
        },
        value: {},
        config: {
            type: Object,
            default() {
                return {
                    data: []
                };
            }
        },
        applyWarningClass: {
            type: Boolean,
            default: true,
        },
        state: {
            type: Boolean,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            componentValue: this.value
        };
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
        }
    },
}
</script>

<template>
    <div>
        <div v-if="readOnly">
            <h5>{{ $t('Component(CompositionSubstance):scip-interval') }}</h5>
            <div class="mb-1">{{ value ? value.title : '-' }}</div>
        </div>
        <b-form-group
            v-else
            :class="{ 'is-invalid': state === false }"
        >
            <template #label>
                {{ $t('Component(CompositionSubstance):scip-interval') }}
                <span v-if="required" class="text-danger ml-50">
                    {{ $t('Component(Text):required') }}
                </span>
            </template>
            <v-select
                v-model="componentValue"
                label="title"
                :class="{ 'input-bg-warning': applyWarningClass && state === null }"
                :title="$t('Component(CompositionSubstance):hover-scip-interval')"
                :options="config.data"
                @input="onInput"
                :placeholder="$t('Component(CompositionSubstance):scip-interval-placeholder')"
                :disabled="readOnly"
            />
        </b-form-group>
    </div>
</template>
